// extracted by mini-css-extract-plugin
export default {"image":"cardImages-module__image__CXAK1"};